import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ type: "spring", stiffness: 110, damping: 18, delay }}
  >
    {children}
  </motion.div>
);

export const LineReveal = ({ lines, className = "", lineClassName = "", baseDelay = 0.15 }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <div key={i} className="overflow-hidden py-0.5">
        <motion.div
          initial={{ y: "115%", rotate: 3 }}
          animate={{ y: "0%", rotate: 0 }}
          transition={{ type: "spring", stiffness: 90, damping: 16, delay: baseDelay + i * 0.16 }}
          className={lineClassName}
        >
          {line}
        </motion.div>
      </div>
    ))}
  </div>
);
